APPS.course.environmentalScienceCourseDownloads = (function(e){
	
    var show = function(e){
		if( document.cookie.indexOf('whro_environment') < 0 ) { 
			window.location.replace('http://carlosf-environment.whro.org/environmental-science-course-form');
		}
	    console.log('downloads page')
        APP.getView().showChildView('mainRegion', new pageView() )
			
		window.document.title = 'COURSE DOWNLOADS';
		if(typeof ga !== "undefined" ){ ga('send','pageview',{ page:"/", title:'COURSE DOWNLOADS' }) } 
		}
     
    /***********************************************************************
	 ***********************************************************************
	    VIEWS 
	 ***********************************************************************
	 ***********************************************************************/
        var pageView = Mn.View.extend({
			template: _.template($("#template_environmental_science_course_downloads").html())
			,className:"page_downloads"
			,events: {
				"click #schoologyDownloadBtn": "revealSchoologyCode"
			}
  	        ,revealSchoologyCode:function(e) {
				var schoologyDownloadBtn = document.getElementById("schoologyDownloadBtn");
				var schoologyCodeDescription = document.getElementById("schoologyCodeDescription");
				fetch("/api/environmental_science_course_dl.php?id=19")
					.then(() => {
						schoologyDownloadBtn.innerHTML = "HV6T-B9X8-Z35ZR"
						schoologyDownloadBtn.style.pointerEvents = "none";

					})
					.catch(() => {
						schoologyCodeDescription.innerHTML = "<p class='downloads_description' style='padding-top: 0'>Sorry, you do not have permission to view the Schoology access code. Please complete the download form before accessing this code.</p>";
						schoologyDownloadBtn.remove();
					});
			}
	    })
    return {
        show:show
    }
})();